import axios from 'axios';
import dotenv from '../dotenv';
import { axiosRequestInterceptor } from './interceptor/request';

export const authAxios = axios.create({
  baseURL: dotenv.SERVER,
});

authAxios.interceptors.request.use(axiosRequestInterceptor);
